module.exports = __webpack_public_path__ + "img/switch.87da661d.png";